import styled, { css } from 'styled-components';
import media from '../../constants/media';
import { Column, Columns } from '../base/grid';
import DynamicRspImage from '../base/images/dynamicRspImageBg';
import { liStyles, ulStyles } from '../base/typography';

export const Wrapper = styled.div`
	display: flex;
	align-items: stretch;
	min-height: 55rem;
	margin: 6rem 0;

	${media.tablet`
		margin-bottom: 18rem;
	`};
`;

export const ShowcaseSectionColumns = styled(Columns)`
	width: 100%;
	${({ reverseOrder }) =>
		reverseOrder &&
		css`
			flex-direction: row-reverse;
		`};
`;

export const ImageColumn = styled(Column)``;

export const ContentColumn = styled(Column)`
	&strong {
		color: ${({ theme }) => theme.colors.pureBlack};
		font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	}
`;
export const Text = styled.div`
	color: ${({ theme }) => theme.colors.graySummary};
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 1.8rem;
	margin-top: 2rem;

	strong {
		color: ${({ theme }) => theme.colors.pureBlack};
		font-weight: 700;
	}

	${media.tablet`
		font-size: 2rem;
		margin-top: 3rem;
	`};

	ul {
		${ulStyles};
		margin-bottom: 3rem;
	}

	li {
		${liStyles};
	}
`;

export const ShowcaseSectionImage = styled(DynamicRspImage)`
	height: 100%;
	padding-top: 100%;

	// ${media.desktopSmall`
	// 	padding-top: 60%;
	// `};

	${({ containImage }) =>
		containImage &&
		css`
			background-size: contain;
			background-repeat: no-repeat;
		`}
`;

export const Title = styled.div`
	color: ${({ theme }) => theme.colors.pureBlack};
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
	font-size: 3.5rem;
	line-height: 3.7rem;
	font-weight: 700;
	margin-bottom: 2rem;

	${media.tablet`
		font-size: 4rem;
		line-height: 4.5rem;
		margin-bottom: 3rem;
	`};
`;
export const Subtitle = styled.div`
	color: ${({ theme }) => theme.colors.graySummary};
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 2.25rem;
	line-height: 2.375
	margin-bottom: 1.5rem;

	${media.tablet`
		font-size: 2.6rem;
		line-height: 2.8
		margin-bottom: 3rem;
	`};
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;

	// ${media.desktopSmall`
    //     max-width: 42rem;
	// `};
`;

export const ButtonWrapper = styled.div`
	margin-top: 3rem;
`;
